module.exports = __webpack_public_path__ + "img/fibermak_laser.2c2c4724.png";